import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { usePageTracking } from '~/hooks/usePageTracking';
import NotFoundPage from '~/pages/NotFoundPage';
import SignupPage from '~/pages/SignupPage';
import { getPartner } from '~/queries/getPartner';
import { usePartnerReferralContext } from '~/tracking/usePartnerReferralContext';

import { BaseRouterContext } from '../__root';

interface RouteParams {
  context: BaseRouterContext;
  params: {
    positionId: string;
  };
}

export const Route = createFileRoute('/partner/$positionId')({
  loader: async ({ params, context }: RouteParams) => {
    const data = await context.queryClient.ensureQueryData(
      getPartner(params.positionId),
    );

    if (!data.positionId) {
      console.log('Redirecting to organic');
      redirect({ to: '/', throw: true });
    }
  },
  component: () => {
    const { positionId } = Route.useParams();
    const { data: partner } = useSuspenseQuery(getPartner(positionId));
    const { setPartnerReferralContext } = usePartnerReferralContext();

    usePageTracking('Personalised Signup Page');

    // Set the partner referral context for tracking
    // For direct partner visits, use 'direct' as the lead code
    useEffect(() => {
      if (partner.positionId) {
        setPartnerReferralContext('direct', partner.positionId);
      }
    }, [partner.positionId, setPartnerReferralContext]);

    return <SignupPage partner={partner} showContactButton={true} />;
  },
  errorComponent: NotFoundPage,
});
